function fc_scrollTo(selector,speed){
  if (speed === undefined){
	  speed = 'slow';
  }
  $('html,body').animate({
      scrollTop: $(selector).offset().top},
      speed);
}